const MODULE_NAME = 'micro-sites';

function generateKeyName(value) {
  return [MODULE_NAME, value];
}

const QUERY_KEYS = {
  GET_TOURNAMENT_DETAILS: generateKeyName('tournament-details'),
  GET_TOURNAMENT_BASIC_INFO: generateKeyName('tournament-basic-information'),
  GET_TOURNAMENT_CONTACT_DETAILS: generateKeyName('tournament-contact-details'),
  GET_TOURNAMENT_PRICE_DETAILS: generateKeyName('tournament-price-details'),
  GET_TOURNAMENT_SPORT_LIST: generateKeyName('tournament-sport-list'),
  GET_SPORT_BASIC_INFO: generateKeyName('sport-basic-info'),
  GET_SPORT_EVENTS_LIST: generateKeyName('sport-event-list'),
  GET_SPORT_EVENTS_LIST_DIRECT: generateKeyName('sport-events-list-direct'),
  GET_SPORT_PRICE_DETAILS: generateKeyName('sport-price-details'),
  GET_DRAW_FORMAT: generateKeyName('get-draw-format'),
  GET_POINTS_MEDALS: generateKeyName('get-points-medals'),
  GET_RANKING_TABLE_LIST: generateKeyName('get-ranking-table-list'),
  GET_WINNER_TABLE_LIST: generateKeyName('get-winner-table-list'),
  GET_PARTICIPANT_LIST: generateKeyName('get-participant-list'),
  GET_SPORT_EVENT: generateKeyName('get-sport-event'),
  GET_DRAW_DATE_LIST: generateKeyName('get-draw-dates-list'),
  GET_SPORT_LIST: generateKeyName('sport-list'),
  GET_GENDER: generateKeyName('gender'),
  GET_AGE_CATEGORY: generateKeyName('age-catetory'),
  GET_SPORT_CATEGORY: generateKeyName('sport-category'),
  GET_SUB_CATEGORY: generateKeyName('sub-category'),
  GET_BUILDERIO_PAGE: generateKeyName('builderio-page'),
  GET_SHOW_RECONCILIATION: generateKeyName('show-reconciliation'),
  GET_RULES_PRICE: generateKeyName('get-rules-price'),
  GET_EVENT_ATTRACTIONS: generateKeyName('get-event-attractions'),

  GET_MEDIA_DETAILS: generateKeyName('get-media-details'),
  GET_SPORTS_SCHEDULES: generateKeyName('get-sport-schedules'),
  GET_DRAWS_FILTERS: generateKeyName('get-draws-filters'),
  GET_RANKING_FILTERS: generateKeyName('get-ranking-filters'),
  GET_SUB_CATEGORY_FILTERS: generateKeyName('get-sub-category-filters'),
  GET_GALLERY_SECTIONS: generateKeyName('get-gallery-sections'),
  GET_GALLERY_FOLDERS: generateKeyName('get-gallery-folders'),
  GET_GALLERY_MEDIA: generateKeyName('get-gallery-media'),
  GET_NEWS: generateKeyName('get-news'),
  GET_ADVANCE_LEAGUE_DS: generateKeyName('get-advance-league-ds'),
  GET_ADVANCE_SCORING: generateKeyName('get-advance-scoring'),
  GET_EVENT_TYPES: generateKeyName('get-event-types'),
  GET_GALLERY_BY_SPORTS: generateKeyName('get-gallery-by-sports'),
  GET_SPORTS_NAME: generateKeyName('get-sports-name'),
  GET_STATES_NAME: generateKeyName('get-states-name'),
  GET_PARTICIPANTS_NAME: generateKeyName('get-participants-name'),
  GET_VENUES: generateKeyName('get-venues'),
  GET_MASCOT: generateKeyName('get-mascot'),
  GET_ANTHEM: generateKeyName('get-anthem'),
  GET_ABOUT_US: generateKeyName('get-about-us'),
  GET_SCHEDULE_BANNERS: generateKeyName('get-banners'),
  GET_ABOUT_HEADING: generateKeyName('get-heading'),
  GET_ALL_TOURNAMENTS: generateKeyName('all-tournaments'),
  GET_PARTICPANTS_DETAILS: generateKeyName('participants-details'),
  GET_LANDING_PAGE_SPORTS_LIST: generateKeyName('landing-page-sports-list'),
  GET_LANDING_PAGE_NEWS_LIST: generateKeyName('landing-page-news-list'),
};

export default QUERY_KEYS;
